'use client';

import type { ReactNode } from 'react';
import { useState } from 'react';

import { RegionFinderDialog } from '../../RegionFinderDialog';

interface RegionFinderShortcutProps {
  className?: string;
  children: ReactNode;
}

export const RegionFinderShortcut = ({
  className,
  children,
}: RegionFinderShortcutProps) => {
  const [isDialogOpened, setIsDialogOpened] = useState(false);

  return (
    <>
      <button
        type="button"
        className={className}
        onClick={() => setIsDialogOpened(true)}
      >
        {children}
      </button>
      <RegionFinderDialog
        opened={isDialogOpened}
        onClose={() => setIsDialogOpened(false)}
      />
    </>
  );
};
